import http from '@/services/http';

// The list changes only when BC changes, so it is fetched once per session.
let cachedRequest = null;

const countries = {
  index() {
    if (!cachedRequest) {
      cachedRequest = http.request({
        method: 'get',
        url: '/countries',
      }).catch((error) => {
        cachedRequest = null;
        throw error;
      });
    }
    return cachedRequest;
  },
};

export default countries;
